import ConfigureCustomerComponent from './../configureCustomer/configureCustomer.component';
import AddAdministratorsComponent from './../addAdministrators/addAdministrators.component';
import DeactivateCustomerAdminComponent from './../deactivateCustomerAdmin/deactivateCustomerAdmin.component';
import runExportComponent from './../runExport/runExport.component';

class EditCustomerSectionController {
  constructor(modalLoaderService, impersonationService, authenticationService, $scope, localStorageService) {
    this.name = 'editCustomerSection';
    this.modalLoaderService = modalLoaderService;
    this.impersonationService = impersonationService;
    this.authenticationService = authenticationService;
    this.$scope = $scope;
    this.localStorageService = localStorageService;
  }

  editCustomer(customer) {
    this.modalLoaderService.show(ConfigureCustomerComponent, {customer: customer}, 'configureCustomer__modal');
  }

  addAdministrator(customer) {
    this.modalLoaderService.show(AddAdministratorsComponent, {customer: customer}, 'add-administrators__modal ');
  }

  editUser(customer){
    this.modalLoaderService.show(DeactivateCustomerAdminComponent, {customer: customer}, 'deactivate-customer-admin__modal ');
  }

  runCustomerExport(customer) {
    this.modalLoaderService.show(runExportComponent, {customer: customer}, 'run-export__modal');
  }

  impersonateCustomer(customer) {
    let customerId = customer.id;
    this.impersonationService.impersonate(customerId).then(
      this.onImpersonateSuccess.bind(this),
      this.onImpersonateFailure.bind(this)
    );
  }

  onImpersonateSuccess() {
    this.storeImpersonatedCustomer();
    this.scrollToTop();
    this.updateStatusIndicator();
  }

  storeImpersonatedCustomer() {
    this.localStorageService.set('impersonatingCustomer', this.customer);
  }

  updateStatusIndicator(){
    this.$scope.$emit('impersonate');
  }

  onImpersonateFailure() {
    this.impersonationError = true;
  }

  scrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}

EditCustomerSectionController.$inject = ['modalLoaderService', 'impersonationService', 'AuthenticationService', '$scope', 'localStorageService', 'extractsService'];

export default EditCustomerSectionController;



// WEBPACK FOOTER //
// ./app/components/editCustomerSection/editCustomerSection.controller.js